import * as Yup from 'yup';

export const phoneNumberCreateSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  phone_number: Yup.string().required('Phone number is required'),
  account_sid: Yup.string().required('Account SID is required'),
  auth_token: Yup.string().required('Auth Token is required'),
});

export const assignAgentSchema = Yup.object().shape({
  agent_id: Yup.number().required('Agent is required'),
});

export type PhoneNumberCreateFormValues = Yup.InferType<typeof phoneNumberCreateSchema>;
export type AssignAgentFormValues = Yup.InferType<typeof assignAgentSchema>;
